"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = handleActions;

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var _isFunction = _interopRequireDefault(require("./isFunction"));

var _combineActions = require("./combineActions");

function reduceReducers() {
  for (var _len = arguments.length, reducers = new Array(_len), _key = 0; _key < _len; _key++) {
    reducers[_key] = arguments[_key];
  }

  return function (previous, current) {
    return reducers.reduce(function (p, r) {
      return r(p, current);
    }, previous);
  };
}

function handleAction(types, reducer) {
  var splitTypes = types.split(_combineActions.ACTION_TYPE_DELIMITER);
  return function (state, action) {
    if (!splitTypes.includes(action.type)) {
      return state;
    }

    return (0, _isFunction.default)(reducer) ? reducer(state, action) : state;
  };
}

function handleActions(handlers, defaultState) {
  var reducers = Object.getOwnPropertyNames(handlers).map(function (types) {
    return handleAction(types, handlers[types]);
  });
  var reducer = reduceReducers.apply(void 0, (0, _toConsumableArray2.default)(reducers));
  return typeof defaultState !== 'undefined' ? function () {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : defaultState;
    var action = arguments.length > 1 ? arguments[1] : undefined;
    return reducer(state, action);
  } : reducer;
}

module.exports = exports.default;